export const OPEN_HOMEPAGE = 'OPEN_HOMEPAGE';
export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const CHANGE_CURRENT_LOCATION = 'CHANGE_CURRENT_LOCATION';
export const RESET_CURRENT_LOCATION = 'RESET_CURRENT_LOCATION';
export const APPLY_NEW_FILTER = 'APPLY_NEW_FILTER';
export const FOCUS_MAP  = 'FOCUS_MAP';
export const PRESS_CONTROL_BUTTON = 'PRESS_CONTROL_BUTTON';
export const CHANGE_QUERY_FROM_BUTTON = 'CHANGE_QUERY_FROM_BUTTON';
export const CHANGE_LOCATION_FROM_INPUT = 'CHANGE_LOCATION_FROM_INPUT';



// WEBPACK FOOTER //
// ./src/constants/index.js